import React, { useEffect, useLayoutEffect} from 'react';
import { useDisclosure, Box, Button, Modal, ModalOverlay, ModalContent, ModalHeader, ModalFooter, ModalBody, ModalCloseButton} from "@chakra-ui/react"

export default function ContactModal() {
    const { isOpen, onOpen, onClose } = useDisclosure()
    return (
      <>
        <Button onClick={onOpen}>Get in Touch.</Button>
  
        <Modal isOpen={isOpen} onClose={onClose}>
          <ModalOverlay />
          <ModalContent>
            <ModalHeader></ModalHeader>
            <ModalCloseButton />
            <ModalBody>
            <br/>Personal Contact<br/><br/><hr/><br/>
                e-mail  : <br/>
                xmandriansusanto@gmail.com <br/><br/>
                phone   : <br/>
                (+62) 0821 2000 1278 <br/><br/>
                LinkedIn    : <br/>
                linkedin.com/in/andriansusanto/
                <br/><br/>
            </ModalBody>
            <ModalFooter>
              <Button colorScheme="blue" mr={3} onClick={onClose}>
                Close
              </Button>
            </ModalFooter>
          </ModalContent>
        </Modal>
      </>
    )
  }